import { motion } from "framer-motion";
import { ABOUT_IMAGE } from "../lib/films";
import useInView from "../hooks/useInView";

export const Portrait = () => {
  const [ref, inView] = useInView({ threshold: 0.15 });
  return (
    <section
      id="portrait"
      data-testid="portrait-section"
      ref={ref}
      className="relative bg-bg py-24 md:py-40 overflow-hidden border-t border-white/[0.05]"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-16 font-mono text-[11px] tracking-widest2 uppercase text-muted">
          <span className="w-10 h-px bg-sun" />
          <span className="text-sun">(04)</span>
          <span>Portrait — Fig. 01</span>
        </div>

        <div className="grid grid-cols-12 gap-6 lg:gap-10 items-end">
          <motion.div
            initial={{ opacity: 0, y: 60 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
            className="col-span-12 md:col-span-9 md:col-start-2 relative spotlight"
          >
            <div className="relative aspect-[4/5] md:aspect-[16/10] overflow-hidden clip-corner grain">
              <img
                data-testid="about-image"
                src={ABOUT_IMAGE}
                alt="Jy Tristian Wright — on set"
                className="w-full h-full object-cover portrait-img"
                style={{ objectPosition: "72% center" }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-bg/70 via-transparent to-transparent" />
              <div className="absolute inset-0 bg-gradient-to-r from-bg/50 via-transparent to-bg/30" />

              {/* Corner tags */}
              <div className="absolute top-4 left-4 font-mono text-[10px] tracking-widest2 uppercase text-ink/75">
                DIR. WRIGHT — SCENE 01
              </div>
              <div className="absolute top-4 right-4 font-mono text-[10px] tracking-widest2 uppercase text-sun">
                ◉ EXP · 1/60
              </div>
              <div className="absolute bottom-4 left-4 font-mono text-[10px] tracking-widest2 uppercase text-ink/75">
                35MM · 24FPS · GOLDEN HOUR
              </div>
              <div className="absolute bottom-4 right-4 font-mono text-[10px] tracking-widest2 uppercase text-ink/75">
                FIG. 01
              </div>
            </div>
          </motion.div>

          <motion.aside
            initial={{ opacity: 0, y: 40 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
            className="col-span-12 md:col-span-8 md:col-start-4 mt-8 md:mt-10"
          >
            <div className="font-mono text-[10px] tracking-widest2 uppercase text-muted mb-4">
              A note from the director
            </div>
            <p className="font-display italic text-3xl md:text-4xl lg:text-5xl text-ink/90 leading-[1.05]">
              "You are going to be okay, and bigger than this moment."
            </p>
            <div className="mt-6 font-mono text-[10px] tracking-widest2 uppercase text-sun">
              — J.T.W.
            </div>
          </motion.aside>
        </div>
      </div>
    </section>
  );
};
